import React, { useState } from 'react'
import { FaArrowAltCircleRight } from 'react-icons/fa'
import { toast } from 'react-toastify'
import styles from './VinSearch.module.css'
import { useSaveClientVinSearchMutation } from '../../../../redux/clientData/apiClientData'

const VinSearch = () => {
  const [vinCode, setVinCode] = useState('')
  const [isValidVin, setIsValidVin] = useState(false)
  const [showIframe, setShowIframe] = useState(false)
  const [saveClientVinSearch] = useSaveClientVinSearchMutation()

  const handleVinChange = (e) => {
    const value = e.target.value.toUpperCase()
    setVinCode(value)
    
    if (value.length === 17) {
      const isValid = /* validateVin(value) */ true
      setIsValidVin(isValid)
      if (!isValid) {
        toast.error('Невірний VIN код. Перевірте правильність введення.')
      }
    } else {
      setIsValidVin(false)
    }
  }

  const handleSearchVin = async () => {
    if (vinCode.length !== 17) {
      toast.error('VIN код повинен містити 17 символів')
      return
    }
    
    if (!isValidVin) {
      toast.error('Невірний VIN код. Перевірте правильність введення.')
      return
    }
    await saveClientVinSearch({ vin: vinCode })
    setShowIframe(true)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchVin()
    }
  }

  return (
    <div className={styles.vinSearchMain}>
      <div className={styles.vinSearchContainer}>
        <div className={styles.vinSearchTop}>
          <div className={styles.vinSearchText}>Пошук по VIN:</div>
          <div className={styles.vinSearchInputContainer}>
            <input
              className={`${styles.vinSearchInput} ${vinCode.length === 17 && !isValidVin ? styles.vinSearchInputError : ''}`}
              type="text"
              placeholder="Введіть VIN код (17 символів)"
              onChange={handleVinChange}
              value={vinCode}
              onKeyDown={handleKeyDown}
              maxLength={17}
            />
            {vinCode.length === 17 && !isValidVin && (
              <div className={styles.vinErrorText}>
                Невірний VIN код
              </div>
            )}
            {vinCode.length === 17 && isValidVin && (
              <div className={styles.vinSuccessText}>
                ✓ VIN код валідний
              </div>
            )}
          </div>
          <div className={styles.vinSearchBtnContainer}>
            <button
              onClick={handleSearchVin}
              className={styles.vinSearchBtn}
              disabled={!isValidVin || vinCode.length !== 17}
            >
              <FaArrowAltCircleRight />
            </button>
          </div>
        </div>
        
        {showIframe && isValidVin && (
          <div className={styles.vinIframeContainer}>
            <div className={styles.vinIframeHeader}>
              <h3>Результати пошуку для VIN: {vinCode}</h3>
              <button 
                onClick={() => setShowIframe(false)}
                className={styles.closeIframeBtn}
              >
                ✕
              </button>
            </div>
            <div className={styles.searchVinIframe}>
              <iframe 
                src={`https://auto-vincode.com/form.php?key=ac4558c948fb630221280293a149d64f&vin=${vinCode}`}
                style={{
                  width: '100%',
                  minHeight: '700px',
                  border: '1px solid #eee',
                  borderRadius: '4px'
                }}
                title="VIN Search Results"

              />
            </div>
          </div>
        )}
        
        <div className={styles.vinInfoText}>
          <p><strong>VIN код</strong> - це унікальний 17-значний ідентифікатор транспортного засобу.</p>
          <p>Введіть VIN код вашого автомобіля для отримання детальної інформації про доступні запчастини.</p>
        </div>
      </div>
    </div>
  )
}

export default VinSearch 